import React, { useState, useContext } from 'react';
import './Navbar.scss';
import logo from './../../assets/newmonaassets/logo_mona.png';
import trFlag from './../../assets/newmonaassets/flags/icon_tr.png';
import enFlag from './../../assets/newmonaassets/flags/icon_en.png';
import { Link } from 'react-router-dom';
import { IoChevronDownOutline } from 'react-icons/io5';
import { LanguageContext } from '../../context/LanguageContext';
import OptimizedImage from '../OptimizedImage';

const Navbar = () => {
    const { currentLang, toggleLanguage, t } = useContext(LanguageContext);
    const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);

    const handleLanguageToggle = (lang) => {
        toggleLanguage(lang);
        setIsLangDropdownOpen(false);
    };

    // Logo için özel stil
    const logoStyle = {
        width: '40px',
        height: 'auto',
        maxHeight: '40px',
        objectFit: 'contain'
    };

    const navbarItems = {
        tr: [
            {
                name: 'Ana Sayfa',
                path: '/',
            },
            {
                name: 'Tedavilerimiz',
                path: '/tedaviler',
            },
            {
                name: 'Blog',
                path: '/blogs',
            },
            {
                name: 'Hakkımızda',
                path: '/about',
            },
            {
                name: 'İletişim',
                path: '/contact',
            }
        ],
        en: [
            {
                name: 'Home',
                path: '/en',
            },
            {
                name: 'Treatments',
                path: '/en/treatments',
            },
            {
                name: 'Blog',
                path: '/en/blogs',
            },
            {
                name: 'About Us',
                path: '/en/about',
            },
            {
                name: 'Contact',
                path: '/en/contact',
            }
        ]
    };

    return (
        <div className='main-nav'>
            <div className="container">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        {/* Logo + Brand Name */}
                        <Link className="navbar-brand" to={currentLang === 'tr' ? '/' : '/en'}>
                            <div className="logo-container">
                                <OptimizedImage 
                                    src={logo} 
                                    alt={t('altText.logo')} 
                                    className="brand-logo"
                                    style={logoStyle}
                                />
                            </div>
                            <span className="brand-text">Mona Klinik</span>
                        </Link>
                        
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                                {navbarItems[currentLang].map((navSingle, index) =>
                                    <li className="nav-item" key={index}>
                                        <Link className="nav-link" to={navSingle.path}>
                                            {navSingle.name}
                                        </Link>
                                    </li>
                                )}
                            </ul>
                            
                            {/* Language Selector */}
                            <div className="lang-selector me-3">
                                <button 
                                    className="lang-btn"
                                    onClick={() => setIsLangDropdownOpen(!isLangDropdownOpen)}
                                >
                                    <OptimizedImage 
                                        src={currentLang === 'tr' ? trFlag : enFlag} 
                                        alt={currentLang === 'tr' ? t('altText.trFlag') : t('altText.enFlag')} 
                                        className="flag-icon" 
                                    />
                                    <IoChevronDownOutline className="arrow-icon" />
                                </button>
                                
                                {isLangDropdownOpen && (
                                    <div className="lang-dropdown">
                                        {currentLang === 'tr' && (
                                            <button 
                                                className="lang-option"
                                                onClick={() => handleLanguageToggle('en')}
                                            >
                                                <OptimizedImage src={enFlag} alt={t('altText.enFlag')} className="flag-icon" />
                                            </button>
                                        )}
                                        {currentLang === 'en' && (
                                            <button 
                                                className="lang-option"
                                                onClick={() => handleLanguageToggle('tr')}
                                            >
                                                <OptimizedImage src={trFlag} alt={t('altText.trFlag')} className="flag-icon" />
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Book Appointment Button */}
                            <div className="theme-btn">
                                <Link to={currentLang === 'tr' ? '/contact' : '/en/contact'}>
                                    {currentLang === 'tr' ? 'Randevu Al' : 'Book Appointment'}
                                </Link>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Navbar; 